/**
 * Model policy — advisory capability classes and a discouraged-model denylist.
 */
import { VALID_COMPLEXITY_VALUES } from "./complexity.js";
export const thinkingLevelValues = ["none", "low", "medium", "high"];
export const modelRecommendationSourceValues = ["planner", "user"];
export const modelCategoryValues = ["lightweight", "versatile", "powerful"];
export const complexityValues = VALID_COMPLEXITY_VALUES; // source of truth: ./complexity.ts
export const workerRoleValues = [
    "request-formulator",
    "planner",
    "orchestrator",
    "reviewer",
    "feature-worker",
];
export const capabilityClassValues = ["fast", "balanced", "most-capable"];
export const COMPLEXITY_CLASS = {
    trivial: "fast",
    simple: "fast",
    moderate: "balanced",
    complex: "most-capable",
};
/** Advisory cost policy. Callers WARN and RECORD — never block, never throw. */
export const DISCOURAGED = [/fable/i];
export function isDiscouraged(modelId) {
    return DISCOURAGED.some((pattern) => pattern.test(modelId));
}
//# sourceMappingURL=model-policy.js.map